import * as React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./ProductWYSIWYGEditor.css";

function ProductWYSIWYGEditor(props) {
  const { productInfo, setProductInfo } = props;
  const { placeholder, field } = props;
  const { errorField, setErrorField } = props;
  const { disabled } = props;

  const modules = {
    toolbar: [
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      ['blockquote', 'code-block'],
      [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'align': [] }],
      [{ 'font': [] }],
      ['link'],
      ['clean']
    ],
  };

  const formats = [
    'header',
    'bold', 'italic', 'underline', 'strike',
    'list', 'bullet',
    'color', 'background',
    'align',
    'link'
  ];

  const handleChange = (value) => {
    if (errorField !== undefined && errorField.includes(field)) {
      var errors = errorField.filter((x) => x != field);
      setErrorField([...errors]);
    }
    
    // Use functional update to always get the latest state and preserve all fields
    setProductInfo((prevProductInfo) => ({
      ...prevProductInfo,
      [field]: value,
    }));
  };

  return (
    <div 
      className="product-wysiwyg-editor"
      style={{ 
        textAlign: "left", 
        marginBottom: 10,
      }}
    >
      <div
        className={`quill-wrapper ${errorField !== undefined && errorField.includes(field) ? 'error' : ''}`}
      >
        <ReactQuill
          theme="snow"
          value={productInfo === undefined || productInfo[field] == undefined ? "" : productInfo[field]}
          onChange={handleChange}
          modules={modules}
          formats={formats}
          placeholder={placeholder}
          readOnly={disabled === undefined ? false : disabled}
        />
      </div>
    </div>
  );
}

export default ProductWYSIWYGEditor;
